import React from 'react'
import PropTypes from 'prop-types'
import './social-network-icon.css'
import { makeStyles } from '@material-ui/core'
import Link from '@material-ui/core/Link'

const useStyles = makeStyles((theme) => ({
  svg: {
    stroke: theme.palette.footer.icons,
    margin: theme.spacing(1),
    fill: 'none !important',
    strokeMiterlimit: 10,
    '&:hover': {
      stroke: theme.palette.footer.hover,
    },
  },
}))

const SocialNetworkIcon = ({ link, name, image }) => {
  const classes = useStyles()

  return (
    <Link href={link} aria-label={name} target='_blank' rel='noopener'>
      <div className={classes.svg}>{image}</div>
    </Link>
  )
}

SocialNetworkIcon.propTypes = {
  link: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.node,
}

SocialNetworkIcon.defaultProps = {
  image: null,
}

export default SocialNetworkIcon
